import { FC } from "react";
import styled from "styled-components";
import { Icon } from "../../Icon";
import { expandIconAnimation } from "../../expandIconAnimation";
import { SelectComponentProps } from "./types";

type StyledDropdownIndicatorProps = {
  expanded: boolean;
};

const StyledDropdownIndicator = styled.div<StyledDropdownIndicatorProps>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 0 8px;
  ${expandIconAnimation}
`;

type DropdownIndicatorProps = SelectComponentProps["DropdownIndicator"];

export const DropdownIndicator: FC<DropdownIndicatorProps> = ({
  isFocused,
  selectProps: { isDisabled, menuIsOpen },
}) => (
  <StyledDropdownIndicator
    data-testid="DropdownIndicator"
    expanded={menuIsOpen ?? false}
  >
    {isFocused ? (
      <Icon iconName="chevron-down" iconSize="small" variant="ACTIVE" plain />
    ) : (
      <Icon
        iconName="chevron-down"
        iconSize="small"
        variant={isDisabled ? "DISABLED" : "DEFAULT"}
        plain
      />
    )}
  </StyledDropdownIndicator>
);
